(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
const slider = document.querySelector('.marquee-slider');
const content = document.querySelector('.marquee-content');
const items = [...content.children];

items.forEach(item => {
    content.appendChild(item.cloneNode(true));
});

let speed = 1; 
let currentX = 0;
let isPaused = false;
let isDragging = false;
let startX;
let lastX;

function animate() {
    if (!isPaused && !isDragging) {
        currentX -= speed;
        const totalWidth = content.scrollWidth / 2;
        if (currentX <= -totalWidth) currentX = 0;
        if (currentX > 0) currentX = -totalWidth;
        content.style.transform = `translateX(${currentX}px)`;
    }
    requestAnimationFrame(animate);
}

const startDrag = (e) => {
    isDragging = true;
    startX = (e.pageX || e.touches[0].pageX) - currentX;
    lastX = e.pageX || e.touches[0].pageX;
};

const stopDrag = () => {
    isDragging = false;
};

const moveDrag = (e) => {
    if (!isDragging) return;
    const x = (e.pageX || e.touches[0].pageX);
    
    speed = x < lastX ? 1 : -1;
    lastX = x;

    currentX = x - startX;

    const totalWidth = content.scrollWidth / 2;
    if (currentX <= -totalWidth) {
        currentX += totalWidth;
        startX += totalWidth; 
    }
    if (currentX > 0) {
        currentX -= totalWidth;
        startX -= totalWidth;
    }

    content.style.transform = `translateX(${currentX}px)`;
};

slider.addEventListener('mouseenter', () => isPaused = true);
slider.addEventListener('mouseleave', () => isPaused = false);
slider.addEventListener('mousedown', startDrag);
slider.addEventListener('touchstart', startDrag);
window.addEventListener('mouseup', stopDrag);
window.addEventListener('touchend', stopDrag);
window.addEventListener('mousemove', moveDrag);
window.addEventListener('touchmove', moveDrag);

animate();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
const testimonialsSwiper = new Swiper('.testimonials-swiper', {
    loop: true,
    autoplay: false,
    // autoplay: {
    //     delay: 7000,
    //     disableOnInteraction: false,
    // },
    pagination: {
        el: '.testimonials-main .testimonials-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.testimonials-main .testimonials-button-next',
        prevEl: '.testimonials-main .testimonials-button-prev',
    },
    // speed: 800,
    slidesPerView: 1,
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["who-its-for"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {

  const interval = setInterval(() => {
    const target = document.querySelector('.sls-selling-plan-group-options');
    const targetRadio = document.querySelectorAll('.sls-selling-plan-group-first-line')[2];
    const parent = document.querySelector('.selling-plan-group-options-name-select');

    // also prevent duplicate insertion
    if (target && !document.querySelector('.sls-selling-plan-group-options.manual')) {

      target.insertAdjacentHTML('afterend', `
        <div class="sls-selling-plan-group-options manual">
          <div class="selling-plan-group-options-name-select">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_710_3487)">
              <path d="M12 1.88242e-06C9.40257 0.00156438 6.87577 0.845402 4.79857 2.4046C2.72137 3.96398 1.20577 6.1548 0.479372 8.6486C-0.247188 11.1422 -0.145628 13.8044 0.768972 16.2354C0.835066 16.4106 0.968034 16.5523 1.13857 16.6294C1.30912 16.7065 1.50333 16.7127 1.67849 16.6466C1.85365 16.5805 1.99537 16.4475 2.07247 16.277C2.14958 16.1063 2.15575 15.9121 2.08974 15.737C1.15036 13.2534 1.17724 10.5074 2.16513 8.04257C3.15295 5.57777 5.02973 3.57337 7.42453 2.42577C9.81913 1.27827 12.5573 1.07123 15.0973 1.84553C17.6373 2.61983 19.7943 4.31913 21.1415 6.60733C22.4889 8.89553 22.9284 11.6061 22.3732 14.2027C21.8181 16.7995 20.3086 19.0933 18.1436 20.6307C15.9784 22.1681 13.3152 22.8369 10.6806 22.505C8.04605 22.173 5.63205 20.8645 3.91585 18.8382C3.75296 18.6457 3.49975 18.5548 3.25155 18.5996C3.00343 18.6445 2.79811 18.8183 2.71287 19.0557C2.62763 19.293 2.67552 19.5577 2.83841 19.7502C4.58131 21.8106 6.96781 23.2232 9.61261 23.7602C12.2574 24.2971 15.0058 23.9268 17.4142 22.7092C19.8226 21.4916 21.7502 19.4978 22.8858 17.0498C24.0214 14.6016 24.2987 11.8422 23.6729 9.21717C23.047 6.59217 21.5547 4.25457 19.4367 2.58217C17.3187 0.90975 14.6989 -3.05176e-05 12.0003 -3.05176e-05L12 1.88242e-06Z" fill="#423D3F"/>
              <path d="M9.88242 16.2354V7.7648C9.88164 7.51316 9.74696 7.2809 9.52882 7.15534C9.31078 7.02972 9.04234 7.02972 8.82422 7.15534C8.60618 7.28089 8.4714 7.51316 8.4707 7.7648V16.2354C8.47141 16.487 8.60617 16.7193 8.82422 16.8449C9.04234 16.9705 9.31078 16.9705 9.52882 16.8449C9.74694 16.7193 9.88164 16.487 9.88242 16.2354Z" fill="#423D3F"/>
              <path d="M15.5294 16.2354V7.7648C15.5287 7.51316 15.3939 7.2809 15.1759 7.15534C14.9578 7.02972 14.6893 7.02972 14.4713 7.15534C14.2532 7.28089 14.1185 7.51316 14.1177 7.7648V16.2354C14.1185 16.487 14.2531 16.7193 14.4713 16.8449C14.6893 16.9705 14.9578 16.9705 15.1759 16.8449C15.3939 16.7193 15.5287 16.487 15.5294 16.2354Z" fill="#423D3F"/>
              </g>
              <defs>
              <clipPath id="clip0_710_3487">
              <rect width="24" height="24" fill="white"/>
              </clipPath>
              </defs>
            </svg>
            <label>Pause or cancel at any time</label>
          </div>
        </div>
        <div class="sls-selling-plan-group-options manual">
          <div class="selling-plan-group-options-name-select">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 24C18.6144 24 24 18.6144 24 12C24 5.38559 18.6144 0 12 0C5.3856 0 0 5.38559 0 12C0 18.6144 5.3856 24 12 24ZM12 1.33678C17.8789 1.33678 22.6632 6.12106 22.6632 12C22.6632 17.8789 17.8789 22.6632 12 22.6632C6.12106 22.6632 1.33678 17.8789 1.33678 12C1.33678 6.12106 6.12106 1.33678 12 1.33678Z" fill="#423D3F"/>
              <path d="M13.3369 18.3145C13.3369 20.0959 10.6636 20.0959 10.6636 18.3145C10.6636 16.5332 13.3369 16.5332 13.3369 18.3145Z" fill="#423D3F"/>
              <path d="M12 14.8729C12.367 14.8729 12.6677 14.5723 12.6677 14.2052V5.72061C12.6677 5.35357 12.367 5.05292 12 5.05292C11.6329 5.05292 11.3323 5.35357 11.3323 5.72061V14.2052C11.3323 14.5798 11.6329 14.8729 12 14.8729Z" fill="#423D3F"/>
            </svg>
            <label>
              <a target="_blank" href="https://www.sealsubscriptions.com/articles/how-subscriptions-work">
                Learn More
              </a>
            </label>
          </div>
        </div>
      `);

      parent.insertAdjacentHTML('afterbegin', `
        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.5226 4.49269C17.1141 4.49269 16.7826 4.16021 16.7826 3.75059C16.7826 3.34097 17.1141 3.00849 17.5226 3.00849C19.3012 3.00849 20.9198 3.73892 22.0949 4.91607L22.0978 4.91897C23.2725 6.09903 24 7.72142 24 9.50431C24 11.2915 23.2716 12.9157 22.0978 14.0927C20.9246 15.2693 19.3047 16 17.5226 16H6.47731C4.69725 16 3.07826 15.2693 1.90474 14.0927L1.90185 14.0898C0.728671 12.913 0 11.2895 0 9.5043C0 7.7171 0.728671 6.09271 1.90185 4.91607C3.07567 3.73892 4.69514 3.00849 6.47729 3.00849H12.0523L10.3154 1.26662C10.0267 0.977059 10.0267 0.506734 10.3154 0.217172C10.6042 -0.0723906 11.0731 -0.0723906 11.3619 0.217172L14.3622 3.22597L14.3744 3.23885L14.3756 3.23974L14.3867 3.25173L14.3884 3.25375L14.3983 3.26518L14.4099 3.27895L14.4128 3.28249L14.421 3.29272L14.4246 3.29707L14.4319 3.30697L14.4424 3.32131L14.4467 3.32718L14.4526 3.33596L14.4569 3.3424L14.4625 3.35086L14.4668 3.35786L14.4718 3.36608L14.4764 3.37365L14.4808 3.38154L14.4854 3.38975L14.4895 3.39732L14.4942 3.40577L14.4979 3.4131L14.5023 3.42188L14.5058 3.42921L14.5102 3.43823L14.5134 3.44555L14.5175 3.45489L14.5207 3.46222L14.5244 3.47156L14.5311 3.48847L14.534 3.4958L14.5372 3.50546L14.5399 3.51303L14.5431 3.52237L14.5457 3.53026L14.5484 3.5396L14.5615 3.59162L14.5638 3.60128L14.5652 3.60917L14.5672 3.61972L14.5684 3.62673L14.5751 3.67496L14.5754 3.67963L14.5769 3.69396V3.69751L14.5786 3.73173V3.77022L14.5769 3.80444V3.80799L14.5754 3.82232L14.5751 3.82699L14.5684 3.87522L14.5672 3.88223L14.5652 3.89278L14.5638 3.90067L14.5615 3.91033C14.5577 3.92788 14.5536 3.94511 14.5484 3.96235L14.5457 3.97169L14.5431 3.97958L14.5399 3.98892L14.5372 3.99649L14.534 4.00615L14.5311 4.01348L14.5244 4.03039L14.5207 4.03973L14.5175 4.04706L14.5134 4.0564L14.5102 4.06372L14.5058 4.07274L14.5023 4.08007L14.4979 4.08885L14.4942 4.09617L14.4895 4.10463L14.4854 4.1122L14.4808 4.12041L14.4764 4.1283L14.4718 4.13587L14.4668 4.14409L14.4625 4.15109L14.4569 4.15955L14.4526 4.16599L14.4467 4.17477L14.4424 4.18064L14.4319 4.19498L14.4246 4.20488L14.421 4.20923L14.4128 4.21946L14.4099 4.223L14.3983 4.23677L14.3884 4.2482L14.3867 4.25022L14.3756 4.26221L14.3744 4.2631L14.3622 4.27598L11.3619 7.28478C11.0731 7.57434 10.6042 7.57434 10.3154 7.28478C10.0267 6.99522 10.0267 6.52489 10.3154 6.23533L12.0523 4.49346H6.47729C5.10394 4.49346 3.85442 5.0576 2.94833 5.9663C2.04254 6.87467 1.47997 8.12786 1.47997 9.50507C1.47997 10.8835 2.04196 12.1368 2.94687 13.0455C3.85292 13.953 5.10273 14.5166 6.47727 14.5166H17.5225C18.8959 14.5166 20.1454 13.9524 21.0513 13.044C21.9573 12.1354 22.52 10.8823 22.52 9.50505C22.52 8.1257 21.9582 6.87287 21.0543 5.96628L21.0514 5.96338C20.1473 5.05678 18.8982 4.49351 17.5226 4.49351L17.5226 4.49269Z" fill="#423D3F"/>
        </svg>
      `); 

      clearInterval(interval); // ✅ stop once inserted
    }

  }, 500); // check every 500ms

});

  } catch(e) { console.error(e); }
})();
})();
